const getRealityCheckReducer = state => state.realityCheck;

export default {
  netLossAmount: store => getRealityCheckReducer(store).netLossAmount,
  show: store => !!getRealityCheckReducer(store).show,
  sportSessionDetails: store =>
    getRealityCheckReducer(store).sportSessionDetails
};
